module.exports = __webpack_public_path__ + "img/vertical_4_7_7042.e9829340.png";